<template>
  <div>
    <div class="upload__tip"><label>注：</label>
      <p>1、请【导出】同一月份消耗表，然后修改订单最终收入金额，修改后锁单的订单状态变为待审核。<br />2、点击【批量修改（订单最终收入金额）】上传修改后的消耗表。<br />3、待审核的订单不允许修改，修改无效！</p>
    </div>
    <el-upload ref="batchUpload" :action="URL.BASEURL + URL.batchUpdate" :on-success="uploadBatchSuccess" :on-error="uploadError" :data="{
                admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                reason: this.batchUpdateReason
            }" :show-file-list='true' :auto-upload="false" :on-change='changeUpload' :file-list="uploadList" :on-remove='removeFile' :limit='1' :on-exceed='fileExceed' accept=".xlsx,.xls">
      <button class="uploadFileButton">选取文件</button>
    </el-upload>
    <div style="margin-top:20px">
      <label style="vertical-align: top;">修改原因：</label>
      <el-input style="width:280px" type="textarea" size="mini" :rows="2" placeholder="请输入内容" v-model="batchUpdateReason">
      </el-input>
    </div>
    <el-button size="small" type="primary" @click="submitBatchUpdate" style="display:block;margin:30px auto 0;">确定修改</el-button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      batchUpdateReason: '',
      uploadList: [],
    }
  },
  methods: {
    uploadBatchSuccess (res, file, fileList) {
      this.$refs.batchUpload.clearFiles();
      this.uploadList = [];
      this.$loading(this.$loadingConfig).close()
      if (res.errno == 0) {
        this.$emit('updateList')
        this.$message({
          message: '上传成功',
          type: 'success'
        })
      } else {
        var errHint = ''
        if (Array.isArray(res.rst.error)) {
          errHint = '<p>有误字段：</p><ul>'
          res.rst.error.forEach((item) => {
            errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
          })
          errHint += '</ul>'
        } else {
          errHint = res.rst.error
        }
        this.$alert(errHint, res.err, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
    },
    uploadError (err, file, fileList) {
      this.$refs.batchUpload.clearFiles();
      this.$loading(this.$loadingConfig).close();
      this.$message({
        message: '上传失败',
        type: 'fail'
      })
    },

    fileExceed (file) {
      this.$message({
        message: '超出限制，一次仅允许上传一个文件！',
        type: 'warning'
      })
    },
    changeUpload (file, fileList) {
      this.uploadList = fileList;
    },
    removeFile (file) {
      this.uploadList = this.uploadList.filter((v) => {
        return v.name + v.uid != file.name + file.uid
      })
    },
    submitBatchUpdate () {//上传
      if (!this.batchUpdateReason || this.batchUpdateReason == '') {
        this.$message({
          message: '请输入修改原因',
          type: 'warning'
        })
        return
      }
      if (this.uploadList.length <= 0) {
        this.$message({
          message: '请选择上传的文件',
          type: 'warning'
        })
        return;
      }
      this.$loading(this.$loadingConfig)
      this.$refs.batchUpload.submit();
    },
  }
}
</script>
<style lang="scss" scoped>
.uploadFileButton {
  background: transparent;
  border: none;
  color: #5c7bfe;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 3px;
  border: 1px solid #5c7bfe;
}
.upload__tip {
  font-size: 12px;
  line-height: 20px;
  margin-top: -26px;
  margin-bottom: 16px;
  label {
    vertical-align: top;
  }
  p {
    width: calc(100% - 30px);
    display: inline-block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Order/saler/batchUpdate.vue